'use client';
import React from 'react';
import { AuthenticationManager, LoggingManager } from '@benzinga/session';
import { SessionContext } from '@benzinga/session-context';
import { useIsUserLoggedIn } from './hooks/useIsUserLoggedIn';
import { LoginRegister, LoginRegisterEventsTypes } from './loginRegister';
import { useNavigate } from 'react-router-dom';

interface Props {
  onClose?: (upgraded: boolean) => void;
}

export const LoginPrompt: React.FC<Props> = props => {
  const session = React.useContext(SessionContext);
  const loggedIn = useIsUserLoggedIn();
  const sessionChanged = React.useRef(false);
  const navigate = useNavigate();
  const onLoginEvent = React.useCallback(
    (event: { type: LoginRegisterEventsTypes; next?: string }) => {
      switch (event.type) {
        case 'login_succeed':
        case 'start_trial_succeed':
          session.getManager(AuthenticationManager).postLoginGetSession(true, undefined);
          props.onClose?.(true);
          break;
        case 'already_logged_in':
          session.getManager(AuthenticationManager).getAuthSession(true, undefined);
          props.onClose?.(true);
          break;
        case 'register_succeed':
          navigate(new URL(event.next ?? '/dashboard/').pathname);
          sessionChanged.current = true;
          break;
        case 'login_failed':
        case 'register_failed':
          session.getManager(LoggingManager).log(
            'warn',
            {
              category: 'Login',
              message: event.type,
            },
            ['console'],
          );
          break;
        case 'close':
          if (sessionChanged.current === true) {
            session.getManager(AuthenticationManager).getAuthSession(true, undefined);
          }
          props.onClose?.(sessionChanged.current);
          break;
      }
    },
    [navigate, props, session],
  );

  if (loggedIn) {
    return null;
  }
  return <LoginRegister modalMode={true} onEvent={onLoginEvent} />;
};
